import { render } from "./SelectServicio.vue?vue&type=template&id=6e985453&scoped=true"
import script from "./SelectServicio.vue?vue&type=script&lang=js"
export * from "./SelectServicio.vue?vue&type=script&lang=js"

import exportComponent from "/mnt/gasoil_files/gasoil/docker/boletiland/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e985453"]])

export default __exports__